module.exports = __webpack_public_path__ + "static/media/back-button.571c0d0a.png";